import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CardLinkButtonComponent } from './card-link-button/card-link-button.component';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { CardLinkedSingleComponent } from './card-linked-single/card-linked-single.component';
import { CardLinkOfferItemComponent } from './card-link-offer-item/card-link-offer-item.component';
import { CardLinkOffersListComponent } from './card-link-offers-list/card-link-offers-list.component';
import { CardLinkSuccessContentComponent } from './card-link-success-content/card-link-success-content.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CardLinkedListComponent } from './card-linked-list/card-linked-list.component';
import { CardLinkedTransactionsListComponent } from './card-linked-transactions-list/card-linked-transactions-list.component';
import { DateRangePickerModule } from '@fgb/portal-component-library/src/lib/shared/date-range-picker';
import { AffiliatesOffersCategoryFilterComponent, CategoryWidthPipe } from './affiliates-offers-category-filter/affiliates-offers-category-filter.component';
import { CardLinkOfferDetailsComponent } from './card-link-offer-details/card-link-offer-details.component';
import { CardLinkExternalUrlModalComponent } from './card-link-external-url-modal/card-link-external-url-modal.component';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { RouterModule } from '@angular/router';
import { CardLinkingFeaturedOffersComponent } from './card-linking-featured-offers/card-linking-featured-offers.component';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { CardLinkEarnStepsComponent } from './card-link-earn-steps/card-link-earn-steps.component';
import { CardLinkFeaturedBrandsComponent } from './card-link-featured-brands/card-link-featured-brands.component';
import { CardLinkingSingleFeaturedOfferComponent } from './card-linking-single-featured-offer/card-linking-single-featured-offer.component';
import { FormsModule } from '@angular/forms';
import { TermsAndConditionsModule } from '@fgb/portal-component-library/src/lib/club/terms-and-conditions';
import { CardLinkOfferLocationsComponent } from './card-link-offer-locations/card-link-offer-locations.component';
import { CardLinkOfferLocationsMapComponent } from './card-link-offer-locations-map/card-link-offer-locations-map.component';
import { CardLinkOfferLocationsListComponent } from './card-link-offer-locations-list/card-link-offer-locations-list.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
  declarations: [
    CardLinkButtonComponent,
    CardLinkedSingleComponent,
    CardLinkedListComponent,
    CardLinkedTransactionsListComponent,
    CardLinkSuccessContentComponent,
    CardLinkOfferItemComponent,
    CardLinkOffersListComponent,
    AffiliatesOffersCategoryFilterComponent,
    CardLinkOfferDetailsComponent,
    CardLinkExternalUrlModalComponent,
    CardLinkingFeaturedOffersComponent,
    CardLinkEarnStepsComponent,
    CardLinkFeaturedBrandsComponent,
    CardLinkingSingleFeaturedOfferComponent,
    CardLinkOfferLocationsComponent,
    CardLinkOfferLocationsMapComponent,
    CardLinkOfferLocationsListComponent,
    CategoryWidthPipe
  ],
  imports: [
    CommonModule,
    NgbModule,
    DateRangePickerModule,
    PipesModule,
    CarouselModule,
    LoadingModule,
    RouterModule,
    DirectivesModule,
    FormsModule,
    GoogleMapsModule,
    TermsAndConditionsModule,
    FGBSharedModule
  ],

  exports: [
    CardLinkButtonComponent,
    CardLinkedSingleComponent,
    CardLinkedListComponent,
    CardLinkedTransactionsListComponent,
    CardLinkSuccessContentComponent,
    CardLinkOfferItemComponent,
    CardLinkOffersListComponent,
    AffiliatesOffersCategoryFilterComponent,
    CardLinkOfferDetailsComponent,
    CardLinkExternalUrlModalComponent,
    CardLinkingFeaturedOffersComponent,
    CardLinkEarnStepsComponent,
    CardLinkFeaturedBrandsComponent,
    CardLinkOfferLocationsComponent
  ],
})
export class CardLinkModule {}
